import { dayjs } from '@karve.it/core';

/**
 * Whether the value names a real calendar day: a `YYYY-MM-DD` date (or a
 * full ISO timestamp — storage has held both). Day.js's non-strict parser
 * ROLLS overflow components (2026-02-30 → March 2, month 13 → next year)
 * while still reporting valid, so the parsed value must round-trip to the
 * same day (CodeRabbit). Anything that doesn't is rejected, not normalized.
 */
function isRealCalendarDate(value: string): boolean {
    const parsed = dayjs(value);
    if (!parsed.isValid()) { return false; }
    return parsed.format('YYYY-MM-DD') === value.trim().slice(0, 10);
}

/**
 * The date the schedule should open at (CodeRabbit round 3 — a stored
 * `schedule-date` used to beat an explicit `?date=` URL param, so bookmarks
 * and deep links landed on the previously-viewed day, found twice in the
 * run log and confirmed by the review).
 *
 * Precedence:
 * 1. an explicit, valid `date` query param (bookmark / deep link wins),
 * 2. the session's last-used schedule date,
 * 3. today (caller-provided ISO — pinned in tests).
 */
export function selectScheduleSeedDate(
    routeDate: string | null | undefined,
    savedDate: string | null | undefined,
    todayIso: () => string = () => new Date().toISOString(),
): string {
    if (routeDate && isRealCalendarDate(routeDate)) { return routeDate; }
    if (savedDate && isRealCalendarDate(savedDate)) { return savedDate; }
    return todayIso();
}